import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const Quiz = lazy(() => import('../pages/quiz/page'));
const Result = lazy(() => import('../pages/result/page'));
const UraShindan = lazy(() => import('../pages/ura-shindan/page'));
const Success = lazy(() => import('../pages/success/page'));
const Tokushoho = lazy(() => import('../pages/tokushoho/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const JiraiQuiz = lazy(() => import('../pages/jirai-quiz/page'));
const JiraiResult = lazy(() => import('../pages/jirai-result/page'));

const PageLoader = () => (
  <div
    className="min-h-screen flex items-center justify-center"
    style={{ background: '#FAF8FF' }}
  >
    <div
      className="w-8 h-8 rounded-full border-2 animate-spin"
      style={{ borderColor: 'rgba(167,139,250,0.4)', borderTopColor: 'transparent' }}
    />
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: '/quiz',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Quiz />
      </Suspense>
    ),
  },
  {
    path: '/result/:code',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Result />
      </Suspense>
    ),
  },
  {
    path: '/ura-shindan/:code',
    element: (
      <Suspense fallback={<PageLoader />}>
        <UraShindan />
      </Suspense>
    ),
  },
  {
    path: '/success',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Success />
      </Suspense>
    ),
  },
  {
    path: '/tokushoho',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Tokushoho />
      </Suspense>
    ),
  },
  {
    path: '/privacy',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Privacy />
      </Suspense>
    ),
  },
  {
    path: '/jirai-quiz',
    element: (
      <Suspense fallback={<PageLoader />}>
        <JiraiQuiz />
      </Suspense>
    ),
  },
  {
    path: '/jirai-result/:code',
    element: (
      <Suspense fallback={<PageLoader />}>
        <JiraiResult />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
